import SearchSelect from "@ui-components/SearchSelect";
import { useEffect, useState } from "react";
import GetWonData from "@feature/worksites/terminate-modal/modals/won-workflow/data";
import GetLostData from "@feature/worksites/terminate-modal/modals/lost-workflow/data";
import { useIntl } from "react-intl";
type Props = {
  worksiteTerminationFilter: string | undefined,
  setWorksiteTerminationFilter: (value: string | undefined) => void,
  worksiteTerminationReasonFilter: string | undefined,
  setWorksiteTerminationReasonFilter: (value: string | undefined) => void,
}
export const WorksiteTerminatedFilter = ({
  worksiteTerminationFilter,
  setWorksiteTerminationFilter,
  worksiteTerminationReasonFilter,
  setWorksiteTerminationReasonFilter,
  }: Props) => {
  const intl = useIntl();
  const {channelOptions} = GetWonData(intl.formatMessage);
  const {brandChannelOptions} = GetLostData(intl.formatMessage);
  const [reasonOptions, setReasonOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    if (worksiteTerminationFilter === "won") {
      setReasonOptions(channelOptions);
    } else if (worksiteTerminationFilter === "lost") {
      setReasonOptions(brandChannelOptions);
    } else {
      setReasonOptions([]);
    }
  }, [worksiteTerminationFilter]);

  const wonLostOptions = [
    {
      value: "won", label: intl.formatMessage({
        id: "terminate_reason_won",
        defaultMessage: "Realizzato con almenouna soluzione Kerakoll",
      })
    },
    {
      value: "lost", label: intl.formatMessage({
        id: "terminate_reason_lost",
        defaultMessage: "Realizzato con altre soluzioni",
      })
    },
  ]


  return (
    <div>
      <SearchSelect
        label={intl.formatMessage({
          id: "worksite_won_lost",
          defaultMessage: "vinto/perso",
        })}
        value={wonLostOptions.find((option) => option.value === worksiteTerminationFilter) || null}
        options={wonLostOptions}
        isClearable
        onChange={(e: any) => {
          setWorksiteTerminationFilter(e?.value);
          setWorksiteTerminationReasonFilter(undefined);
        }}
      />
      {worksiteTerminationFilter && (
        <SearchSelect
          label={
            worksiteTerminationFilter === "won"
              ? intl.formatMessage({
                id: "terminate_reason_won_channel_label",
                defaultMessage: "Canale utilizzato",
              })
              : intl.formatMessage({
                id: "terminate_reason_lost_channel_label",
                defaultMessage: "Motivazione",
              })
          }
          value={reasonOptions.find((option) => option.value === worksiteTerminationReasonFilter) || null}
          options={reasonOptions}
          onChange={(e: any) => setWorksiteTerminationReasonFilter(e?.value)}
          isClearable
        />
      )}
    </div>
  )
}